import {
    getBrandList,
    getBrand,
} from "../apis/api_brand.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, sort: 'seq'},
    items: [],
    item: {},    
};

const getters = {
};

const mutations = {
    SET_BRAND_LIST(state, items){
        state.items = items;
    },

    SET_BRAND(state, payload) {
        state.item = payload
    },

    CLEAR_BRAND(state) {
        state.item = {};
    },
};

const actions = {

    async GET_BRAND_LIST({ state, commit }) {
        try {
            const response = await getBrandList(state.filters);
            commit('SET_BRAND_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_BRAND({ commit }, id) {
        try {
            const response = await getBrand(id);
            commit('SET_BRAND', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};